import { Outlet, useLocation } from 'react-router-dom'
import Header from './Header'
import Footer from './Footer'

export default function Layout() {
  const location = useLocation()
  // Pages that should use full width (no padding) - like code editors
  const fullWidthPages = ['/scripts/new', '/scripts/']
  const isFullWidth = fullWidthPages.some(path => location.pathname.startsWith(path))
  
  return (
    <div className="h-screen bg-background flex flex-col">
      <Header />
      <main className={`flex-1 ${isFullWidth ? 'h-full overflow-hidden' : 'container mx-auto px-4 py-6'}`}>
        <Outlet />
      </main>
      {!isFullWidth && <Footer />}
    </div>
  )
}
